import { render, staticRenderFns } from "./navbarBottom.vue?vue&type=template&id=6c10e312&scoped=true&"
import script from "./navbarBottom.vue?vue&type=script&lang=js&"
export * from "./navbarBottom.vue?vue&type=script&lang=js&"
import style0 from "./navbarBottom.vue?vue&type=style&index=0&id=6c10e312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c10e312",
  null
  
)

export default component.exports